import React from 'react';
import useDocumentCart from './hooks/useDocumentCart';
import FocusTrap from 'focus-trap-react';
import Spinner from '../../components/Spinner';

function DocumentCart(props) {
  const { labels, ...config } = useDocumentCart({ ...props });

  return (
    <>
      <FocusTrap active={config.showCartModal} focusTrapOptions={{
        fallbackFocus: document.activeElement,
        clickOutsideDeactivates: true,
        allowOutsideClick: true
      }}>
        <div
          aria-hidden={!config.showCartModal}
          className={`document-cart${config.showCartModal ? '' : ' visibility-hidden'}`}
          onClick={config.handleCloseClick}
        >
          <div
            className={`document-cart__inner${config.showCartModal ? '' : ' document-cart__inner--hidden'}`}
            role="dialog"
          >
            <header className="document-cart__heading">
              <p className="document-cart__title">{config.docsBtnString}</p>
              <button
                aria-label={labels.closeModal}
                className="modal__close-button"
                onClick={config.handleCloseClick}
                tabIndex="0"
                title={labels.closeModal}
              >
                <svg height="24" role="presentation" viewBox="0 0 120 120" width="24">
                  <use xlinkHref="#close-regular" />
                </svg>
              </button>
            </header>
            <ul className="document-cart__list">
              {config.errorMessage ? (<li className="document-cart__item document-cart__error">{config.errorMessage}</li>) : ''}
              {
                config.docs?.map(($item, $i) => (
                  <li className="document-cart__item" key={$item.docUrl}>
                    <div className="document-cart__item-header">
                      <p className="document-cart__doc-type">{$item.docType}</p>
                      <button
                        aria-label={labels.removeFromCart}
                        className="document-cart__trash-btn"
                        data-idx={String($i)}
                        onClick={config.handleDeleteClick}
                      >
                        <svg height="16" role="presentation" viewBox="0 0 16 16" width="16">
                          <use xlinkHref="#trash" />
                        </svg>
                      </button>
                    </div>
                    <p className="document-cart__doc-name">{$item.docName}</p>
                  </li>
                ))
              }
            </ul>
            <footer className="document-cart__footer">
              <div className="document-cart__footer-buttons">
                <button
                  className="btn siplast--sg btn--primary btn--large document-cart__export-btn"
                  type="button"
                  onClick={config.handleExportClick}
                >
                  {labels.export}
                  <svg
                    className="btn__icon"
                    height="22"
                    role="presentation"
                    viewBox="0 0 120 120"
                    width="22"
                  >
                    <use xlinkHref="#download-regular" />
                  </svg>
                </button>
                <button
                  className="btn siplast--sg btn--primary btn--large document-cart__email-btn"
                  type="button"
                  disabled={!config.showEmailButton}
                  onClick={config.handleEmailClick}
                >
                  {labels.email}
                  <svg
                    className="btn__icon"
                    height="22"
                    role="presentation"
                    viewBox="0 0 120 120"
                    width="22"
                  >
                    <use xlinkHref="#icon-mail" />
                  </svg>
                </button>
              </div>
              <button
                className="document-cart__clear-btn"
                type="button"
                onClick={config.handleClearAll}
              >{labels.clearAll}</button>
            </footer>
            <div aria-hidden="true" className="modal document-cart__modal" id="document-cart-modal">
              <div className="modal__backdrop">
                <div aria-label="" className="modal__container">
                  <header className="modal__header">
                    <h2 className="modal__title"> </h2>
                    <button className="modal__close-button" title="Close modal" aria-label="Close modal" tabIndex="-1">
                      <svg role="presentation" width="15" height="15" viewBox="0 0 120 120">
                        <use xlinkHref="#close-regular"></use>
                      </svg>
                    </button>
                  </header>
                  <div className="modal__content rtf" dangerouslySetInnerHTML={{ __html: labels.modalMessage }} />
                  <footer className="modal__summary">
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>

      </FocusTrap>
      <button
        aria-hidden={!config.showDocsButton}
        className={`btn siplast--sg btn--primary btn--large document-cart__btn${
          (config.showDocsButton && !config.showCartModal) ? '' : ' document-cart__btn--hidden'}`
        }
        disabled={!config.showDocsButton}
        onClick={config.handleDocsButtonClick}
        type="button"
      >{config.docsBtnString}</button>
      <Spinner loading={config.isLoading} />
    </>
  );
}

export default DocumentCart;
